<div class="live-alerts">
    <div class="header">
        <div class="title">
            <i class="fas fa-bell"></i>
            <span>Live Alerts</span>
            <div class="loading-indicator" *ngIf="isLoading">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
        </div>
        <app-search-filter
            [config]="filterConfig"
            [placeholder]="'Filter alerts'"
            [userId]="userId"
            (filter)="onFilter($event)"
            (clear)="onClearFilters()"
        ></app-search-filter>
    </div>

    <div class="alerts-list">
        <div
            class="alert-card"
            *ngFor="let a of filteredAlerts"
            [class]="'alert-card ' + a.severity"
        >
            <div
                class="severity-bar"
                [class]="'severity-bar ' + a.severity"
            ></div>
            <div class="alert-content">
                <div class="alert-title">{{ a.title }}</div>
                <div class="alert-scope">
                    <img
                        src="/assets/img/location.svg"
                        alt="location"
                        class="icon"
                    />
                    <span>{{ a.scope }}</span>
                </div>
                <div class="alert-suggestion" *ngIf="a.aiInsight?.suggestion">
                    <span class="chip"
                        >AI Suggestion: {{ a.aiInsight.suggestion }}</span
                    >
                </div>
                <div class="actions">
                    <button class="btn btn-view" (click)="openAlertDetails(a)">
                        View
                    </button>
                    <button
                        class="btn btn-resolve"
                        [disabled]="resolvingId === a.notificationId"
                        (click)="onResolve(a)"
                    >
                        {{
                            resolvingId === a.notificationId
                                ? 'Resolving…'
                                : 'Resolve'
                        }}
                    </button>
                    <span class="time-ago">{{ a.timeAgo }}</span>
                </div>
            </div>
        </div>

        <!-- Empty state message -->
        <div *ngIf="filteredAlerts.length === 0" class="empty-state">
            <div class="empty-state-icon">
                <i class="fas fa-bell-slash"></i>
            </div>
            <div class="empty-state-message">
                <h4>No Live Alerts</h4>
            </div>
        </div>
    </div>
</div>

<!-- Alert Details Dialog -->
<p-dialog
    [(visible)]="dialogVisible"
    [modal]="true"
    [dismissableMask]="true"
    [closable]="true"
    [position]="'center'"
    [baseZIndex]="3000"
    [blockScroll]="true"
    [appendTo]="'body'"
    [breakpoints]="{'960px': '95vw', '640px': '98vw'}"
    [style]="{width: '800px'}"
    [contentStyle]="{padding: '2rem', overflow: 'auto', maxHeight: '80vh'}"
>
    <ng-template pTemplate="header">
        <div class="dialog-header">
            <span class="dialog-title">{{
                selectedAlert?.title || 'Loading...'
            }}</span>
        </div>
    </ng-template>

    <div class="dialog-body" *ngIf="!dialogLoading && selectedAlert">
        <div class="dialog-row">
            <span class="label">Type of alert</span>
            <span class="value">{{
                selectedAlert?.alertType || selectedAlert?.title
            }}</span>
        </div>
        <div
            class="dialog-row"
            *ngIf="
                selectedAlert?.value !== null &&
                selectedAlert?.value !== undefined
            "
        >
            <span class="label">Value</span>
            <span class="value">{{ selectedAlert?.value }}</span>
        </div>
        <div class="dialog-row">
            <span class="label">Timestamp</span>
            <span class="value">{{
                selectedAlert?.timestamp | date: 'medium'
            }}</span>
        </div>
        <div class="dialog-row">
            <span class="label">Location</span>
            <span class="value">{{
                selectedAlert?.location ||
                    selectedAlert?.farmName +
                        ' / ' +
                        selectedAlert?.farmHouseName
            }}</span>
        </div>
        <div class="dialog-row">
            <span class="label">Severity</span>
            <span class="value">
                <span class="badge" [ngClass]="selectedAlert?.severity">{{
                    selectedAlert?.severity || 'info'
                }}</span>
            </span>
        </div>
        <div class="dialog-row" *ngIf="selectedAlert?.aiInsightResult">
            <span class="label">AI Insight</span>
            <div class="value ai-insight-details">
                <div
                    class="ai-suggestion"
                    *ngIf="selectedAlert.aiInsightResult.suggestion"
                >
                    <strong>Suggestion:</strong>
                    {{ selectedAlert.aiInsightResult.suggestion }}
                </div>
                <div
                    class="ai-rationale"
                    *ngIf="selectedAlert.aiInsightResult.rationale"
                >
                    <strong>Rationale:</strong>
                    {{ selectedAlert.aiInsightResult.rationale }}
                </div>
                <div
                    class="ai-actions"
                    *ngIf="
                        selectedAlert.aiInsightResult.aiInsightActions?.length
                    "
                >
                    <strong>Recommended Actions:</strong>
                    <ul>
                        <li
                            *ngFor="
                                let action of selectedAlert.aiInsightResult
                                    .aiInsightActions
                            "
                            [class]="'priority-' + action.priority"
                        >
                            {{ action.title }}
                        </li>
                    </ul>
                </div>
                <div class="ai-disclaimer-box">
                    <i class="fas fa-exclamation-triangle"></i>
                    <span
                        ><strong>Note:</strong>AI model is still learning about
                        your environment to improve accuracy of the
                        results</span
                    >
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-body" *ngIf="dialogLoading">
        <div class="loading-container">
            <i class="fas fa-spinner fa-spin"></i>
            <p>Loading alert details...</p>
        </div>
    </div>
</p-dialog>
